import { useEffect, useState } from "react";
import styles from "../styles/pages/cdp/cdp.module.scss";

import { Title } from "../shared/components/Title";

import { Button, Drawer, Loading } from "@components";
import { useLocation, useNavigate } from "react-router";
import { Add } from "shared/components/Add";
import { If } from "shared/components/control-statements";
import { AudiencesTable } from "shared/containers/cdp/audiences/AudiencesTable";
import ContextSearch from "shared/containers/oraculo/ContextSearch";

import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import { Icon } from "shared/components/core/Icon";
import { InputSearch } from "shared/components/InputSearch";
import FullDatabase from "./FullDatabase";
import OcdpAPI2 from "providers/OcdpAPI2";
import { Environment } from "shared/core/Environment";
import { Numbers } from "shared/utils/Numbers";
import dayjs from "dayjs";
import { UserStorage } from "shared/tools/UserStorage";
import BaseMarking from "shared/containers/cdp/BaseMarking";

const ocdp_api = new OcdpAPI2();

export default function Cdp() {
  const [audiences, setAudiences] = useState([]);
  const [openContextSearch, setOpenContextSearch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [context, setContext] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState("base-de-dados");
  const [selectedTabFullDataBase, setSelectedTabFullDataBase] = useState(null);
  const [selectedAudience, setSelectedAudience] = useState(null);
  const [brands, setBrands] = useState(null);
  const [totals, setTotals] = useState(null);
  const [percentage, setPercentage] = useState(null);
  const [loadingImportAudience, setLoadingImportAudience] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [openBaseMarking, setOpenBaseMarking] = useState(false);

  const navigate = useNavigate();

  const userRole = UserStorage.getLoggedUser()?.role;

  useEffect(() => {
    const statusEnv = localStorage.getItem("status-environment");

    const isOnboarding = statusEnv === "ONBOARDING";

    if (window.location.href.indexOf("?cdp") < 0 && !isOnboarding) {
      window.location.href = window.location.href + "?cdp";
    }
  }, []);

  useEffect(() => {
    const loadBrands = async () => {
      const unitsResponse = await OlgaEnvironmentsAPI.getUnits();
      const units = unitsResponse.getData([]);

      const brandsResponse = await OlgaEnvironmentsAPI.getBrands();
      const brands = brandsResponse.getData([]);

      if ((units.items || []).length > 0) {
        for (const brand of brands)
          brand.units = (units || []).filter(
            (unit) => unit.brand_id === brand.id,
          );
      }

      setBrands(brands);
    };

    loadBrands();
  }, []);

  const updateContext = ({ type, brand, unit, multi_brand }) => {
    setContext({
      type,
      brand,
      unit,
      multi_brand,
    });
  };

  const fetchData = async () => {
    setLoading(true);
    const configs = Environment.configurations;

    if (configs.ocdp_execution_id_v2) {
      const execution_id = configs.ocdp_execution_id_v2;
      const current_totals = (await ocdp_api.totals(execution_id)) || 0;
      const last_month_totals =
        (await ocdp_api.cache_totals(
          dayjs().subtract(30, "day").format("YYYY-MM-DD"),
        )) || 1;

      setTotals(current_totals);
      setPercentage(Numbers.formatInt(current_totals - last_month_totals));
    } else {
      setTotals(0);
    }

    await fetchAudiences();

    setLoading(false);
  };

  const fetchAudiences = async () => {
    const audiences = await ocdp_api.audiences();

    const filtered_audiences = audiences.filter((a) => a.state != "ARCHIVED");

    const sortedAudiences = filtered_audiences.sort(
      (a, b) =>
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
    );

    setAudiences(
      sortedAudiences.map((a) => ({
        id: a.id,
        name: a.name,
        type: a.type,
        status: a.status,
        brand_id: a.brand_id,
        brand: a.brand || { id: a.brand_id },
        unit_id: a.unit_id,
        unit: a.unit || { id: a.unit_id },
        schema: a.schema,
        filters: a.filters,
        boxes: a.boxes,
        links: a.links,
        state: a.state,
        execution_id: a.execution_id,
        qtd_customers: a.customers || 0,
        previous_qtd_customers: a.previous_customers || 0,
        qtv_variables: a.schema?.length || 0,
        sort: a.extras?.sort,
        limit: a.extras?.limit,
        version: a.version,
        updated_at: a.updated_at,
      })),
    );
  };

  const installAudience = async () => {
    setLoadingImportAudience(true);
    await ocdp_api.installAudiences();
    setLoadingImportAudience(false);
    window.location.reload();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredAudiences = audiences.filter((c) => {
    return !!search
      ? c.name?.toLowerCase().includes(search.toLowerCase())
      : true;
  });

  const totalUnits =
    brands?.length > 0
      ? Array.from(
          new Map(
            (brands || [])
              .flatMap((item) => item?.units)
              .map((unit) => [unit?.id, unit]),
          ).values(),
        ).length
      : 0;

  return (
    <>
      <If cond={currentPage === "base-de-dados"}>
        <Title title="Base de Dados">
          <div className="d-flex align-center gap-10">
            <InputSearch
              placeholder="Buscar por..."
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* <Button
              design="default-icon-mini"
              onClick={() => navigate("/base-de-dados/tratamento-de-base")}
            >
              <Icon name="fa-layer-group" light />
            </Button> */}
            <Button
              design="default-icon-mini"
              onClick={() => navigate("/base-de-dados/publicos-arquivados")}
            >
              <Icon name="fa-box-archive" light />
            </Button>
            {/* The Famous ou Fogo no chão */}
            <If cond={Environment.id === 51 || Environment.id === 108}>
              <Button onClick={() => setOpenOptions(true)}>
              <i className="fal fa-ellipsis-v" />
            </Button>
            </If>
            <If cond={userRole === "SUPPORT"}>
              <Button
                design="default-icon-mini"
                title={"Instalar públicos padrão"}
                loading={loadingImportAudience}
                disabled={loadingImportAudience}
                onClick={() => installAudience()}
              >
                <Icon name="fa-upload" />
              </Button>
            </If>
          </div>
        </Title>

        <If cond={loading}>
          <div className={styles.loading}>
            <Loading />
          </div>
        </If>

        <If cond={!loading}>
          <div className={styles.bases}>
            <div
              className={styles.base}
              onClick={() => {
                setCurrentPage("base-completa");
                setSelectedAudience(null);
                setSelectedTabFullDataBase(null);
              }}
            >
              <div className="d-flex align-center justify-between">
                <div className="d-flex flex-column">
                  <div className={styles.icon}>
                    <i className="far fa-database" />
                  </div>
                  <p>Base completa</p>
                  <div className="d-flex align-center">
                    <span>
                      {totals === null
                        ? "-"
                        : `${Numbers.formatInt(totals)} hoje`}
                    </span>
                    {/* {percentage !== null && (
                      <span
                        className={css({
                          growth: true,
                          up: percentage >= 0,
                          down: percentage < 0,
                        })}
                      >
                        <i className="fal fa-arrow-trend-up" />
                        {percentage}
                      </span>
                    )} */}
                  </div>
                </div>

                <div className={styles.chevron}>
                  <i className="fas fa-chevron-right" />
                </div>
              </div>
            </div>
            <div
              className={styles.base}
              onClick={() => setOpenContextSearch(true)}
            >
              <div className="d-flex align-center justify-between">
                <div className="d-flex flex-column">
                  <div className={styles.icon}>
                    <i className="far fa-store" />
                  </div>
                  <p>Bases isoladas</p>
                  <div className="d-flex align-center">
                    <span>
                      {brands?.length > 1
                        ? `${brands?.length} marcas`
                        : "1 marca"}
                    </span>
                    <span>&nbsp;/&nbsp;</span>
                    <span>
                      {totalUnits > 1 ? `${totalUnits} unidades` : "1 unidade"}
                    </span>
                  </div>
                </div>

                <div className={styles.chevron}>
                  <i className="fas fa-chevron-right" />
                </div>
              </div>
            </div>
            <Add
              text="Criar público"
              className="d-flex flex-column"
              onClick={() => {
                setCurrentPage("base-completa");
                setSelectedTabFullDataBase("create-audience");
              }}
            />
          </div>

          <AudiencesTable
            audiences={filteredAudiences}
            onSelect={(audience) => {
              setCurrentPage("base-completa");
              setSelectedAudience(audience);
            }}
            onChange={() => fetchAudiences()}
          />
        </If>
      </If>

      <If cond={currentPage === "base-completa"}>
        <FullDatabase
          onClose={() => {
            setSearch("");
            setSelectedTabFullDataBase(null);
            setSelectedAudience(null);
            setCurrentPage("base-de-dados");
            fetchData();
          }}
          selectedTabFullDataBase={selectedTabFullDataBase}
          audience={selectedAudience}
          context={context}
        />
      </If>

      <ContextSearch
        visible={openContextSearch}
        onChangeContext={(context) => {
          updateContext(context);
          setCurrentPage("base-completa");
          setOpenContextSearch(false);
        }}
        onClose={() => setOpenContextSearch(false)}
      />

      <Drawer
        visible={openOptions}
        onClose={() => setOpenOptions(false)}
        title="Ver mais"
      >
        <div className={styles.options}>
          <div
            className={styles.option}
            onClick={() => setOpenBaseMarking(true)}
          >
            <div className={styles.icon}>
              <i className="fal fa-tags" />
            </div>
            <p>Marcação de base</p>
          </div>
        </div>
      </Drawer>

      <BaseMarking
        open={openBaseMarking}
        onClose={() => setOpenBaseMarking(false)}
      />
    </>
  );
}
